(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["size-chart"] && !Shopify.designMode) return;
  try {
    class SizeChartComponent extends HTMLElement {
    constructor() {
      super();
      this.tabsContainer = null;
      this.inchesTab = null;
      this.cmTab = null;
      this.table = null;
      this.currentUnit = 'cm';
    }

    connectedCallback() {
      setTimeout(() => {
        this.initialize();
      }, 0);
    }

    initialize() {
      this.tabsContainer = this.querySelector('.size-chart__tabs');
      this.inchesTab = this.querySelector('[data-unit="inches"]');
      this.cmTab = this.querySelector('[data-unit="cm"]');
      this.table = this.querySelector('.size-chart__table');

      if (this.tabsContainer && this.inchesTab && this.cmTab && this.table) {
        this.showTabs();
        this.bindEvents();
        this.updateTableContent(); // Ensure table shows correct values on load
      }
    }

    showTabs() {
      if (this.tabsContainer) {
        this.tabsContainer.style.display = 'flex';
      }
    }

    bindEvents() {
      if (this.inchesTab) {
        this.inchesTab.addEventListener('click', () => this.switchUnit('inches'));
      }
      if (this.cmTab) {
        this.cmTab.addEventListener('click', () => this.switchUnit('cm'));
      }
    }

    switchUnit(unit) {
      if (unit === this.currentUnit) return;

      this.currentUnit = unit;
      this.updateTabStates();
      this.updateTableContent();
    }

    updateTabStates() {
      if (this.inchesTab) {
        this.inchesTab.classList.toggle('size-chart__tab--active', this.currentUnit === 'inches');
      }
      if (this.cmTab) {
        this.cmTab.classList.toggle('size-chart__tab--active', this.currentUnit === 'cm');
      }
    }

    updateTableContent() {
      if (!this.table) return;
      
      const cells = this.table.querySelectorAll('td[data-value-inches][data-value-cm]');
      
      cells.forEach(cell => {
        const inchesValue = cell.getAttribute('data-value-inches') || '';
        const cmValue = cell.getAttribute('data-value-cm') || '';
        
        if (this.currentUnit === 'inches') {
          cell.textContent = inchesValue;
        } else {
          cell.textContent = cmValue;
        }
      });
    }
  }

  customElements.define('size-chart-component', SizeChartComponent);
  } catch(e) { console.error(e); }
})();

})();
